import React, { useEffect, useState, useRef } from "react";

const PUBLIC_URL = process.env.PUBLIC_URL || "";

const DESKTOP_BANNER_FILES = [
  "BANNIERE KAZAMANSA-01a.jpg",
  "BANNIERE KAZAMANSA-02a.jpg",
  "BANNIERE KAZAMANSA-03a.jpg",
  "BANNIERE KAZAMANSA-04a.jpg",
  "BANNIERE KAZAMANSA-05a.jpg",
  // "BANNIERE KAZAMANSA-06a.jpg",
];

const MOBILE_BANNER_FILES = [
  "BANNIERE KAZAMANSA-01a_Mobile.jpg",
  "BANNIERE KAZAMANSA-02a_Mobile.jpg",
  "BANNIERE KAZAMANSA-03a_Mobile.jpg",
  "BANNIERE KAZAMANSA-04a_Mobile.jpg",
  "BANNIERE KAZAMANSA-05a_Mobile.jpg",
  // "BANNIERE KAZAMANSA-06a_Mobile.jpg",
];

const desktopUrls = DESKTOP_BANNER_FILES.map(
  (name) => `${PUBLIC_URL}/Banniere/${encodeURIComponent(name)}`
);

const mobileUrls = MOBILE_BANNER_FILES.map(
  (name) => `${PUBLIC_URL}/Banniere/${encodeURIComponent(name)}`
);

/** Aligné sur le breakpoint `.kazamansa-hero-banner` dans `index.css` */
const MOBILE_MEDIA_QUERY = "(max-width: 767px)";
/** Intervalle de rotation automatique (ms) */
const AUTOPLAY_INTERVAL = 4000;

function BannerHomepage() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(MOBILE_MEDIA_QUERY).matches
      : false
  );
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Détection mobile / desktop
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  // Rotation automatique (desktop ET mobile)
  useEffect(() => {
    const urls = isMobile ? mobileUrls : desktopUrls;
    timerRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % urls.length);
    }, AUTOPLAY_INTERVAL);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isMobile]);

  const urls = isMobile ? mobileUrls : desktopUrls;

  const goTo = (index: number) => {
    setActiveIndex(index);
    // Réinitialiser le timer quand on clique manuellement
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % urls.length);
    }, AUTOPLAY_INTERVAL);
  };

  return (
    <section
      className="section-banner-homepage kazamansa-hero-banner"
      aria-label="Bannière Kazamansa"
    >
      <div className="kazamansa-hero-slides" aria-hidden>
        {urls.map((src, i) => (
          <img
            key={src}
            src={src}
            alt=""
            loading={i === 0 ? "eager" : "lazy"}
            decoding="async"
            fetchPriority={i === 0 ? "high" : undefined}
            className={`kazamansa-hero-slide${i === activeIndex ? " is-active" : ""}`}
          />
        ))}
      </div>
      <div className="kazamansa-hero-dots" role="tablist" aria-label="Sélection des bannières">
        {urls.map((src, i) => (
          <button
            key={`hero-dot-${src}`}
            type="button"
            role="tab"
            aria-label={`Afficher la bannière ${i + 1}`}
            aria-selected={i === activeIndex ? "true" : "false"}
            className={`kazamansa-hero-dot${i === activeIndex ? " is-active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </section>
  );
}

export default BannerHomepage;
